import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/plugins.css";
import "./assets/css/style.css";
import "./assets/css/products.css";
import "react-slideshow-image/dist/styles.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExistDataProvider from "./components/shared/context/dataExist-context";
import "swiper/css";
import "swiper/css/navigation";
import CartProvider from "./components/shared/context/cart-context";
import ShoppingProvider from "./components/shared/context/shopping-context";
import "bootstrap/dist/css/bootstrap.min.css";
import { RouterProvider } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/configureStore";
import { router } from "./router";
import BasketProvider from "./context/BasketProvider";

function Index() {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

// import "bootstrap/dist/css/bootstrap.min.css";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <>
        <BasketProvider>
          <ShoppingProvider>
            <CartProvider>
              <ExistDataProvider>
                <ToastContainer />
                <RouterProvider router={router} />
              </ExistDataProvider>
            </CartProvider>
          </ShoppingProvider>
        </BasketProvider>
      </>
    </Provider>
  </React.StrictMode>
);

export default Index;
